// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconTag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
            <path
                fill="currentColor"
                d="M0,0.65625 C0,0.29390645 0.293906093,0 0.65625,0 L5.03437507,0 C5.33343744,0 5.75109386,0.172992468 5.96249986,0.384374857 L10.1156244,4.53750014 C10.6282024,5.05007815 10.6282024,5.8811717 10.1156058,6.39374971 L6.39373112,10.1156244 C5.88115311,10.6282024 5.0500592,10.6282024 4.53771544,10.1155844 L0.384590507,5.96245909 C0.17299211,5.75156236 0,5.33437514 0,5.03437507 L0,0.65625 Z M1.875,2.625 C1.875,3.03937483 2.21085942,3.375 2.625,3.375 C3.03914058,3.375 3.375,3.03937483 3.375,2.625 C3.375,2.21062517 3.03914058,1.875 2.625,1.875 C2.21085942,1.875 1.875,2.21015596 1.875,2.625 Z"
            />
        </svg>
    );
};

export default React.memo(IconTag);
